// extracted by mini-css-extract-plugin
module.exports = {"productImage":"ueCZf","productBadge":"_3e1aR","badge":"_1ZrDV","defaultImage":"_2gR0R"};